(() => {
  if (window.sfMobileInitialized) return;
  window.sfMobileInitialized = true;
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 999px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const interfaceElement = document.querySelector('sf-mobile-interface');
  const openedDialogs = new Set();
  const dialogTriggers = new WeakMap();

  function closeDialog(dialog) {
    if (dialog?.open) dialog.close();
  }

  function openDialog(dialog, trigger) {
    if (!dialog) return;
    for (const open of openedDialogs) closeDialog(open);
    dialogTriggers.set(dialog, trigger);
    trigger?.setAttribute('aria-expanded', 'true');
    dialog.showModal();
    openedDialogs.add(dialog);
    root.classList.add('sfm-dialog-open');
  }

  document.querySelectorAll('.sfm__sheet, .sfm-zoom').forEach(dialog => {
    dialog.addEventListener('close', () => {
      openedDialogs.delete(dialog);
      dialogTriggers.get(dialog)?.setAttribute('aria-expanded', 'false');
      if (!openedDialogs.size) root.classList.remove('sfm-dialog-open');
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
    });
    dialog.querySelectorAll('[data-sfm-close]').forEach(button => button.addEventListener('click', () => closeDialog(dialog)));
  });

  document.querySelectorAll('[data-sfm-zoom-trigger]').forEach(button => {
    const media = button.closest('product-media');
    const dialog = document.getElementById(button.getAttribute('aria-controls'));
    if (!media || !dialog) return;
    const images = JSON.parse(dialog.querySelector('[data-sfm-zoom-data]').textContent);
    const imageElement = dialog.querySelector('[data-sfm-zoom-image]');
    const stage = dialog.querySelector('.sfm-zoom__stage');
    const counter = dialog.querySelector('[data-sfm-zoom-count]');
    const enlarge = dialog.querySelector('[data-sfm-enlarge]');
    let index = 0;
    let scale = 1, offsetX = 0, offsetY = 0;
    let lastTap = null, multiplePointers = false, lastTouchAt = 0;
    const pointers = new Map();

    function paintZoom() {
      const fit = Math.min(stage.clientWidth / imageElement.width, stage.clientHeight / imageElement.height);
      const maxX = Math.max(0, (imageElement.width * fit * scale - stage.clientWidth) / 2);
      const maxY = Math.max(0, (imageElement.height * fit * scale - stage.clientHeight) / 2);
      offsetX = Math.max(-maxX, Math.min(maxX, offsetX));
      offsetY = Math.max(-maxY, Math.min(maxY, offsetY));
      imageElement.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
      stage.toggleAttribute('data-enlarged', scale > 1.01);
      enlarge.setAttribute('aria-pressed', String(scale > 1.01));
    }

    function zoomAt(nextScale, from, to = from) {
      const ratio = Math.max(1, Math.min(4, nextScale)) / scale;
      const rect = stage.getBoundingClientRect();
      const cx = rect.left + rect.width / 2, cy = rect.top + rect.height / 2;
      offsetX = to.x - cx - (from.x - cx - offsetX) * ratio;
      offsetY = to.y - cy - (from.y - cy - offsetY) * ratio;
      scale *= ratio;
      paintZoom();
    }

    function toggleZoom(point) {
      const rect = stage.getBoundingClientRect();
      zoomAt(scale > 1.01 ? 1 : 2, point || { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 });
    }

    function gesture() {
      const [a, b] = [...pointers.values()];
      return b ? { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2, distance: Math.hypot(a.x - b.x, a.y - b.y) } : a;
    }

    stage.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.pointerType === 'touch') lastTouchAt = Date.now();
      event.preventDefault();
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY, startX: event.clientX, startY: event.clientY, moved: false });
      if (pointers.size > 1) { multiplePointers = true; lastTap = null; }
      stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointermove', event => {
      const previous = pointers.get(event.pointerId);
      if (!previous) return;
      const before = gesture();
      pointers.set(event.pointerId, { ...previous, x: event.clientX, y: event.clientY, moved: previous.moved || Math.hypot(event.clientX - previous.startX, event.clientY - previous.startY) > 8 });
      const after = gesture();
      if (pointers.size > 1 && before.distance > 0) zoomAt(scale * after.distance / before.distance, before, after);
      else if (scale > 1) { offsetX += after.x - before.x; offsetY += after.y - before.y; paintZoom(); }
    });
    function endPointer(event) {
      const point = pointers.get(event.pointerId);
      pointers.delete(event.pointerId);
      if (event.type === 'pointerup' && point && !point.moved && !multiplePointers && event.pointerType !== 'mouse') {
        const now = Date.now();
        if (lastTap && now - lastTap.time < 320 && Math.hypot(point.x - lastTap.x, point.y - lastTap.y) < 30) { toggleZoom(point); lastTap = null; }
        else lastTap = { ...point, time: now };
      }
      if (!pointers.size) multiplePointers = false;
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
    stage.addEventListener('lostpointercapture', event => pointers.delete(event.pointerId));
    stage.addEventListener('dblclick', event => { if (Date.now() - lastTouchAt > 600) toggleZoom({ x: event.clientX, y: event.clientY }); });
    new ResizeObserver(() => { if (dialog.open) paintZoom(); }).observe(stage);

    function selectImage(nextIndex) {
      index = (nextIndex + images.length) % images.length;
      const image = images[index];
      imageElement.src = image.src;
      imageElement.alt = image.alt;
      imageElement.width = image.width;
      imageElement.height = image.height;
      counter.textContent = `${index + 1} / ${images.length}`;
      scale = 1; offsetX = 0; offsetY = 0;
      lastTap = null; multiplePointers = false; pointers.clear();
      paintZoom();
      dialog.querySelector('[data-sfm-zoom-prev]').disabled = images.length < 2;
      dialog.querySelector('[data-sfm-zoom-next]').disabled = images.length < 2;
    }

    function openImage(trigger, mediaId) {
      if (!images.length) return;
      const current = media.querySelector('.product__media-item.is-selected');
      const selectedIndex = images.findIndex(image => String(image.id) === (mediaId || current?.dataset.mediaId));
      selectImage(Math.max(0, selectedIndex));
      openDialog(dialog, trigger);
      paintZoom();
    }
    button.addEventListener('click', event => {
      event.preventDefault();
      openImage(button);
    });
    media.querySelectorAll('.product__media-image-wrapper').forEach(wrapper => {
      wrapper.setAttribute('role', 'button');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('aria-label', `${dialog.getAttribute('aria-label')}: ${wrapper.querySelector('img').alt}`);
      wrapper.setAttribute('aria-haspopup', 'dialog');
      wrapper.setAttribute('aria-controls', dialog.id);
      wrapper.setAttribute('aria-expanded', 'false');
      let start = null, dragged = false;
      wrapper.addEventListener('pointerdown', event => {
        if (start) { dragged = true; return; }
        start = { x: event.clientX, y: event.clientY, id: event.pointerId };
        dragged = false;
      });
      wrapper.addEventListener('pointermove', event => {
        if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 8) dragged = true;
      });
      wrapper.addEventListener('pointercancel', () => { start = null; dragged = true; });
      wrapper.addEventListener('pointerup', () => { start = null; });
      wrapper.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        if (!dragged) openImage(wrapper, wrapper.closest('[data-media-id]').dataset.mediaId);
      });
      wrapper.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openImage(wrapper, wrapper.closest('[data-media-id]').dataset.mediaId);
      });
    });
    dialog.querySelector('[data-sfm-zoom-prev]').addEventListener('click', () => selectImage(index - 1));
    dialog.querySelector('[data-sfm-zoom-next]').addEventListener('click', () => selectImage(index + 1));
    enlarge.addEventListener('click', () => toggleZoom());
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); selectImage(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); selectImage(index + 1); }
    });
  });

  document.querySelectorAll('.product__info [data-sf-delivery-estimate]').forEach(panel => {
    const wrapper = document.createElement('div');
    wrapper.className = 'sfm-delivery';
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'sfm-delivery__toggle';
    panel.id ||= `${panel.querySelector('input').id}-panel`;
    toggle.setAttribute('aria-controls', panel.id);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z"/><circle cx="12" cy="10" r="2.5"/></svg><span>Prazo de entrega</span><span class="sfm-delivery__action">Consultar CEP</span>';
    panel.before(wrapper);
    wrapper.append(toggle, panel);
    toggle.addEventListener('click', () => {
      if (!mobile.matches) return;
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(expanded));
      if (expanded) panel.querySelector('input').focus({ preventScroll: true });
    });
  });

  if (!interfaceElement) return;
  if (interfaceElement.dataset.mode === 'client') {
    const sizeSelectors = [];
    document.querySelectorAll('.product__info product-variants .product-form__option-selector').forEach(selector => {
      const name = selector.querySelector('.product-form__option-name');
      if (!/(tamanho|size|talla)/i.test(name?.textContent || '')) return;
      const nativeSelect = selector.querySelector('select[name^="option"]');
      const radios = [...selector.querySelectorAll('input[type=radio][name^="option"]')];
      const values = nativeSelect ? [...nativeSelect.options].map(option => option.value) : radios.map(input => input.value);
      if (!values.length) return;
      selector.classList.add('sfm-size');
      const originalName = name.textContent;
      const updateName = () => { name.textContent = mobile.matches ? 'Tamanho:' : originalName; };
      mobile.addEventListener('change', updateName);
      updateName();
      sizeSelectors.push(selector);
      if (values.length < 2) return;
      selector.classList.add('sfm-size--multiple');
      const compact = document.createElement('select');
      compact.className = 'sfm-size-select';
      compact.setAttribute('aria-label', name.textContent.trim().replace(/:$/, ''));
      // No option name: the original theme controls remain the only variant inputs.
      values.forEach(value => compact.add(new Option(value, value)));
      const sync = () => {
        compact.value = nativeSelect ? nativeSelect.value : radios.find(input => input.checked)?.value || '';
        [...compact.options].forEach(option => {
          const original = nativeSelect ? [...nativeSelect.options].find(item => item.value === option.value) : radios.find(input => input.value === option.value);
          option.disabled = Boolean(original?.disabled);
        });
      };
      compact.addEventListener('change', event => {
        event.stopPropagation();
        const original = nativeSelect || radios.find(input => input.value === compact.value);
        if (!original) return;
        if (nativeSelect) nativeSelect.value = compact.value;
        else original.checked = true;
        original.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      selector.querySelector('.product-form__option-info').append(compact);
      selector.addEventListener('change', event => { if (event.target !== compact) sync(); });
      const originalInput = nativeSelect || radios[0];
      document.getElementById(originalInput.getAttribute('form'))?.addEventListener('variant:changed', sync);
      sync();
    });

    document.querySelectorAll('.product__info sf-product-measurements').forEach(summary => {
      const anchor = document.createComment('Original measurement summary position');
      summary.before(anchor);
      summary.classList.add('sfm-size-summary');
      const guide = summary.querySelector('[data-sf-wrist-open]');
      const label = guide?.querySelector('span:not(.sf-wrist-guide-button__arrow)');
      const originalLabel = label?.textContent;
      const target = sizeSelectors.at(-1);
      summary.toggleAttribute('data-sfm-size-option', Boolean(target));
      const normalize = text => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\bde\b/g, '').replace(/[^a-z0-9]/g, '');
      const update = () => {
        if (mobile.matches && target) target.after(summary);
        else anchor.after(summary);
        if (label) label.textContent = mobile.matches ? 'Como medir seu pulso?' : originalLabel;
        const value = target?.querySelector('.product-form__option-value')?.textContent || '';
        const measure = summary.querySelector('[data-sf-measure]')?.textContent || '';
        const numbers = text => (text.match(/\d+(?:[.,]\d+)?/g) || []).join('|');
        const sameAdjustableRange = /ajust[aá]vel/i.test(value) && /pulso/i.test(measure) && /cm/i.test(value) && /cm/i.test(measure) && numbers(value) && numbers(value) === numbers(measure);
        summary.toggleAttribute('data-sfm-duplicate-measure', Boolean(value && measure && (normalize(value) === normalize(measure) || sameAdjustableRange)));
        const note = summary.querySelector('[data-sf-measure-note]')?.textContent.trim() || '';
        summary.toggleAttribute('data-sfm-guide-instruction', /^Meça seu pulso sem apertar a pele, conforme o guia abaixo\.?$/i.test(note));
      };
      const form = document.getElementById(summary.getAttribute('form-id'));
      form?.addEventListener('variant:changed', () => requestAnimationFrame(update));
      mobile.addEventListener('change', update);
      update();
    });
  }
  const bottom = interfaceElement.querySelector('[data-sfm-bottom]');
  const nav = interfaceElement.querySelector('.sfm__nav');
  const purchase = interfaceElement.querySelector('[data-sfm-purchase]');
  const mainForm = document.querySelector('.product__info form[is="product-form"]');
  const originalButton = mainForm?.querySelector('[data-product-add-to-cart-button]');
  const mainOptions = document.querySelector('.product__info .product-form__variants');
  const productData = interfaceElement.querySelector('[data-sfm-product]');
  const product = productData ? JSON.parse(productData.textContent) : null;
  let selectedVariant = product?.variant || null;
  const purchaseData = interfaceElement.querySelector('[data-sf-purchase-data]');
  const purchaseConfig = purchaseData ? JSON.parse(purchaseData.textContent) : null;
  const buyNow = mainForm?.querySelector('[data-sf-buy-now]');
  const buyStatus = mainForm?.querySelector('[data-sf-buy-status]');
  let buying = false;
  let addedPurchase = null;

  function syncBuyNow() {
    if (!buyNow) return;
    buyNow.disabled = buying || !selectedVariant?.available || Boolean(originalButton?.disabled) || originalButton?.getAttribute('aria-busy') === 'true';
    buyNow.setAttribute('aria-busy', String(buying));
    buyNow.textContent = buying ? purchaseConfig.labels.loading : selectedVariant?.available ? purchaseConfig.labels.buy : purchaseConfig.labels.unavailable;
  }

  const cartSignature = cart => JSON.stringify([cart.token, cart.items.map(item => [item.key, item.quantity])]);
  async function purchaseRequest(url, options = {}) {
    const response = await fetch(url, { ...options, signal: AbortSignal.timeout(25000) });
    const body = await response.json();
    if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : purchaseConfig.labels.error);
    return body;
  }

  buyNow?.addEventListener('click', async () => {
    if (buying || !selectedVariant?.available || originalButton.disabled) return;
    if (!mainForm.reportValidity()) return;
    const data = new FormData(mainForm);
    data.set('id', String(selectedVariant.id));
    data.set('quantity', data.get('quantity') || '1');
    const fingerprint = new URLSearchParams(data).toString();
    buying = true;
    buyStatus.hidden = true;
    syncBuyNow();
    const wasDisabled = originalButton.disabled;
    originalButton.disabled = true;
    try {
      let cart = addedPurchase ? await purchaseRequest(purchaseConfig.cartUrl) : null;
      if (!addedPurchase || addedPurchase.fingerprint !== fingerprint || addedPurchase.signature !== cartSignature(cart)) {
        addedPurchase = null;
        await purchaseRequest(purchaseConfig.addUrl, { method: 'POST', body: data, credentials: 'same-origin' });
        cart = await purchaseRequest(purchaseConfig.cartUrl);
        addedPurchase = { fingerprint, signature: cartSignature(cart) };
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      }
      if (typeof window.getUrlWithUtmsYever !== 'function' || !window.yeverApi || !window.shopifyDomain) throw new Error(purchaseConfig.labels.error);
      const checkout = await purchaseRequest(window.yeverApi, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ payload: cart, shopifyDomain: window.shopifyDomain })
      });
      if (checkout.active === false || !checkout.url) throw new Error(purchaseConfig.labels.error);
      const destination = new URL(checkout.url);
      if (destination.protocol !== 'https:') throw new Error(purchaseConfig.labels.error);
      window.setUtmCookieYever('yeverCartProperties', window.yeverParseCartItems(cart));
      const discount = cart.discount_codes?.find(code => code.applicable)?.code;
      window.location.assign(window.getUrlWithUtmsYever(destination.href, discount, cart.token));
    } catch (error) {
      buyStatus.textContent = error.name === 'TimeoutError' || error instanceof TypeError ? purchaseConfig.labels.error : error.message || purchaseConfig.labels.error;
      buyStatus.hidden = false;
    } finally {
      buying = false;
      originalButton.disabled = wasDisabled || !selectedVariant?.available;
      syncBuyNow();
    }
  });

  const mediaRoot = document.querySelector('.product__media product-media') || document.querySelector('product-media');
  mediaRoot?.addEventListener('click', event => {
    const thumbnail = event.target.closest('.product__thumbnail-item[data-media-id]');
    if (!thumbnail || !purchaseConfig || !mainForm) return;
    const candidates = purchaseConfig.variants.filter(variant => String(variant.mediaId) === thumbnail.dataset.mediaId);
    if (!candidates.length) return;
    const score = variant => variant.options.reduce((total, value, index) => total + (value === selectedVariant?.options?.[index] ? 1 : 0), 0);
    candidates.sort((a, b) => Number(b.available) - Number(a.available) || score(b) - score(a));
    const variant = candidates[0];
    if (String(variant.id) === String(selectedVariant?.id)) return;
    const changed = [];
    variant.options.forEach((value, index) => {
      const fields = [...mainForm.elements].filter(field => field.name === `option${index + 1}`);
      const select = fields.find(field => field.tagName === 'SELECT');
      if (select) { if (select.value !== value) changed.push(select); select.value = value; }
      else {
        const radio = fields.find(field => field.value === value);
        if (radio) { if (!radio.checked) changed.push(radio); radio.checked = true; }
      }
    });
    changed.forEach(field => field.dispatchEvent(new Event('change', { bubbles: true })));
  });

  function updateDeliveryDates() {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
    const today = Object.fromEntries(parts.filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
    const easter = year => {
      const a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4;
      const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k + 7) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      return new Date(Date.UTC(year, Math.floor((h + l - 7 * m + 114) / 31) - 1, (h + l - 7 * m + 114) % 31 + 1));
    };
    const businessDay = day => {
      if ([0, 6].includes(day.getUTCDay())) return false;
      const key = `${String(day.getUTCMonth() + 1).padStart(2, '0')}-${String(day.getUTCDate()).padStart(2, '0')}`;
      if (['01-01', '04-21', '05-01', '09-07', '10-12', '11-02', '11-15', '11-20', '12-25'].includes(key)) return false;
      const friday = easter(day.getUTCFullYear()); friday.setUTCDate(friday.getUTCDate() - 2);
      return day.getTime() !== friday.getTime();
    };
    document.querySelectorAll('[data-sf-delivery-summary]').forEach(panel => {
      const minimum = Math.max(1, Number(panel.dataset.minDays) || 3);
      const maximum = Math.max(minimum, Number(panel.dataset.maxDays) || 7);
      const day = new Date(Date.UTC(today.year, today.month - 1, today.day));
      let count = 0, first;
      while (count < maximum) {
        day.setUTCDate(day.getUTCDate() + 1);
        if (!businessDay(day)) continue;
        count++;
        if (count === minimum) first = new Date(day);
      }
      const format = date => new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'UTC' }).format(date);
      panel.querySelector('[data-sf-delivery-dates]').textContent = `${format(first)} – ${format(day)}`;
    });
  }
  updateDeliveryDates();
  window.addEventListener('pageshow', updateDeliveryDates);
  const stickyButton = interfaceElement.querySelector('[data-sfm-action="add"]');
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: interfaceElement.dataset.currency || 'BRL' });
  const wishlistDialog = interfaceElement.querySelector('#sfm-wishlist');
  if (wishlistDialog) document.body.append(wishlistDialog);
  const wishlistKey = `sf-wishlist-v1:${location.host}`;
  const wishlistProductData = interfaceElement.querySelector('[data-sfm-wishlist-product]');
  const wishlistProduct = wishlistProductData ? JSON.parse(wishlistProductData.textContent) : null;
  const wishlistStatus = interfaceElement.querySelector('[data-sfm-wishlist-status]');
  let wishToggle = null;
  let updateWishQuantity = null;

  function normalizeWish(item) {
    if (!item || typeof item.id !== 'string' || !/^\d+$/.test(item.id) || typeof item.title !== 'string' || !item.title.trim()) return null;
    try {
      const url = new URL(item.url, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return null;
      let image = '';
      if (item.image) {
        const imageUrl = new URL(item.image, location.origin);
        if (imageUrl.protocol === 'https:' && (imageUrl.host === location.host || imageUrl.hostname === 'cdn.shopify.com')) image = imageUrl.href;
      }
      return { id: item.id, title: item.title.slice(0, 300), url: url.href, image, variant: typeof item.variant === 'string' ? item.variant.slice(0, 200) : '' };
    } catch (_) { return null; }
  }

  function readWishes() {
    try {
      const saved = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      if (!Array.isArray(saved)) return [];
      const valid = saved.map(normalizeWish).filter(Boolean);
      return [...new Map(valid.map(item => [item.id, item])).values()];
    } catch (_) { return []; }
  }
  let wishes = wishlistDialog ? readWishes() : [];

  function announceWish(text, storageBlocked = false) {
    if (!wishlistStatus) return;
    wishlistStatus.textContent = text;
    wishlistStatus.classList.toggle('visually-hidden', !storageBlocked);
  }

  function saveWishes(message) {
    try {
      localStorage.setItem(wishlistKey, JSON.stringify(wishes));
      announceWish(message);
    } catch (_) {
      announceWish('Seu navegador bloqueou o armazenamento. Os desejos ficam disponíveis enquanto esta página estiver aberta.', true);
    }
    renderWishes();
  }

  function renderWishes() {
    if (!wishlistDialog) return;
    document.querySelectorAll('[data-sfm-wishlist-count]').forEach(badge => { badge.textContent = String(wishes.length); });
    document.querySelectorAll('[data-sfm-action=wishlist]').forEach(button => {
      button.setAttribute('aria-label', `Desejos, ${wishes.length} ${wishes.length === 1 ? 'peça salva' : 'peças salvas'}`);
    });
    if (wishToggle) {
      const saved = wishes.some(item => item.id === wishlistProduct.id);
      wishToggle.setAttribute('aria-pressed', String(saved));
      wishToggle.setAttribute('aria-label', saved ? 'Remover peça dos desejos' : 'Salvar peça nos desejos');
      wishToggle.title = saved ? 'Remover dos desejos' : 'Salvar nos desejos';
    }
    const list = wishlistDialog.querySelector('[data-sfm-wishlist-list]');
    const fragment = document.createDocumentFragment();
    wishes.forEach(item => {
      const card = document.createElement('li');
      card.className = 'sfm__wish-item';
      const photo = document.createElement('a');
      photo.href = item.url;
      photo.tabIndex = -1;
      photo.setAttribute('aria-hidden', 'true');
      if (item.image) {
        const image = document.createElement('img');
        image.className = 'sfm__wish-image';
        image.src = item.image;
        image.alt = '';
        image.width = 72; image.height = 72; image.loading = 'lazy';
        photo.append(image);
      }
      const copy = document.createElement('div');
      copy.className = 'sfm__wish-copy';
      const title = document.createElement('a');
      title.className = 'sfm__wish-link'; title.href = item.url; title.textContent = item.title;
      copy.append(title);
      if (item.variant) {
        const variant = document.createElement('span');
        variant.className = 'sfm__wish-variant'; variant.textContent = item.variant;
        copy.append(variant);
      }
      const view = document.createElement('a');
      view.className = 'sfm__wish-view'; view.href = item.url; view.textContent = 'Ver peça';
      copy.append(view);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'sfm__icon-button'; remove.dataset.sfmWishRemove = item.id;
      remove.setAttribute('aria-label', `Remover ${item.title} dos desejos`);
      remove.textContent = '×';
      card.append(photo, copy, remove); fragment.append(card);
    });
    list.replaceChildren(fragment);
    wishlistDialog.querySelector('[data-sfm-wishlist-empty]').hidden = wishes.length > 0;
  }

  if (wishlistDialog) {
    if (wishlistProduct && originalButton) {
      wishToggle = document.createElement('button');
      wishToggle.type = 'button'; wishToggle.className = 'sfm-wish-toggle';
      wishToggle.setAttribute('aria-pressed', 'false');
      wishToggle.append(interfaceElement.querySelector('[data-sfm-wishlist-icon]').content.cloneNode(true));
      const quantity = [...mainForm.elements].find(input => input.name === 'quantity' && input.type !== 'hidden');
      const existingRow = quantity?.closest('.product-form__quantity');
      let quantityRow = existingRow;
      if (existingRow) {
        existingRow.classList.add('sfm-quantity-save');
        existingRow.append(wishToggle);
      } else {
        const row = interfaceElement.querySelector('[data-sfm-wishlist-quantity]').content.firstElementChild.cloneNode(true);
        quantityRow = row;
        const input = row.querySelector('input');
        input.setAttribute('form', mainForm.getAttribute('id'));
        const minus = row.querySelector('[data-sfm-quantity-step="-1"]');
        const plus = row.querySelector('[data-sfm-quantity-step="1"]');
        const syncSteps = () => {
          minus.disabled = Number(input.value) <= Number(input.min);
          plus.disabled = Boolean(input.max) && Number(input.value) >= Number(input.max);
        };
        const normalizeQuantity = () => {
          const minimum = Number(input.min), increment = Number(input.step);
          const value = Number(input.value);
          const valid = Number.isFinite(value) ? minimum + Math.max(0, Math.floor((value - minimum) / increment)) * increment : minimum;
          input.value = String(input.max ? Math.min(Number(input.max), valid) : valid);
          syncSteps();
        };
        updateWishQuantity = variant => {
          const rule = variant?.quantity_rule;
          input.min = String(rule?.min || wishlistProduct.quantityMin || 1);
          input.step = String(rule?.increment || wishlistProduct.quantityStep || 1);
          const maximum = rule ? rule.max : wishlistProduct.quantityMax;
          if (maximum) input.max = String(maximum); else input.removeAttribute('max');
          normalizeQuantity();
        };
        row.querySelectorAll('[data-sfm-quantity-step]').forEach(button => button.addEventListener('click', () => {
          normalizeQuantity();
          if (button.dataset.sfmQuantityStep === '1') input.stepUp(); else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }));
        input.addEventListener('change', normalizeQuantity);
        input.addEventListener('input', syncSteps);
        const syncViewport = () => {
          input.disabled = false;
          syncSteps();
        };
        row.append(wishToggle);
        originalButton.closest('.product-form__buy-buttons').before(row);
        updateWishQuantity(selectedVariant);
        mobile.addEventListener('change', syncViewport);
        syncViewport();
      }
      const productTitle = document.querySelector('.product__info .product-meta__title');
      if (productTitle && quantityRow) {
        const titleRow = document.createElement('div');
        titleRow.className = 'sf-desktop-product-title';
        const positionWishToggle = () => {
          if (mobile.matches) {
            if (titleRow.isConnected) { titleRow.before(productTitle); titleRow.remove(); }
            quantityRow.append(wishToggle);
          } else {
            if (!titleRow.isConnected) { productTitle.before(titleRow); titleRow.append(productTitle); }
            titleRow.append(wishToggle);
          }
          wishToggle.classList.toggle('sfm-wish-toggle--title', !mobile.matches);
        };
        mobile.addEventListener('change', positionWishToggle);
        positionWishToggle();
      }
      wishToggle.addEventListener('click', () => {
        const saved = wishes.some(item => item.id === wishlistProduct.id);
        if (saved) wishes = wishes.filter(item => item.id !== wishlistProduct.id);
        else {
          const url = new URL(wishlistProduct.url, location.origin);
          if (selectedVariant) url.searchParams.set('variant', String(selectedVariant.id));
          const item = normalizeWish({ ...wishlistProduct, url: url.href, image: selectedVariant?.featured_image?.src || wishlistProduct.image, variant: product.hasOnlyDefaultVariant ? '' : selectedVariant?.title || '' });
          if (!item) return;
          wishes.push(item);
        }
        saveWishes(saved ? 'Peça removida dos desejos.' : 'Peça salva em Desejos.');
      });
    }
    wishlistDialog.addEventListener('click', event => {
      const remove = event.target.closest('[data-sfm-wish-remove]');
      if (!remove) return;
      wishes = wishes.filter(item => item.id !== remove.dataset.sfmWishRemove);
      saveWishes('Peça removida dos desejos.');
      (wishlistDialog.querySelector('[data-sfm-wish-remove]') || wishlistDialog.querySelector('[data-sfm-close]')).focus();
    });
    window.addEventListener('storage', event => {
      if (event.key !== wishlistKey && event.key !== null) return;
      wishes = readWishes(); renderWishes();
    });
    window.addEventListener('pageshow', () => { wishes = readWishes(); renderWishes(); });
    renderWishes();
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.sf-desktop-wishlist');
    if (!trigger || !wishlistDialog) return;
    renderWishes(); openDialog(wishlistDialog, trigger);
  });

  function setBottomSpace() {
    if (!mobile.matches) { root.style.removeProperty('--sfm-space'); return; }
    root.style.setProperty('--sfm-space', `${bottom.getBoundingClientRect().height}px`);
  }

  function updatePurchaseVisibility() {
    if (!purchase || !originalButton) return;
    const rect = originalButton.getBoundingClientRect();
    const show = mobile.matches && rect.bottom <= 0;
    purchase.hidden = !show;
    nav.hidden = show;
    setBottomSpace();
  }

  function updateVariant(variant) {
    selectedVariant = variant;
    document.querySelectorAll('[data-sf-cashback]').forEach(benefit => {
      const value = benefit.querySelector('[data-sf-cashback-value]');
      value.textContent = variant ? formatter.format(Math.round(variant.price * Number(benefit.dataset.rate) / 100) / 100) : '—';
    });
    syncBuyNow();
    updateWishQuantity?.(variant);
    if (!product || !stickyButton) return;
    const price = interfaceElement.querySelector('[data-sfm-price]');
    const title = interfaceElement.querySelector('[data-sfm-variant]');
    price.textContent = variant ? formatter.format(variant.price / 100) : '—';
    title.textContent = !variant ? product.labels.options : product.hasOnlyDefaultVariant ? product.labels.options : variant.title;
    stickyButton.textContent = !variant ? product.labels.unavailable : !variant.available ? product.labels.soldOut : product.labels.add;
    stickyButton.disabled = !variant?.available || Boolean(originalButton?.disabled);
  }

  function syncButton() {
    syncBuyNow();
    if (!stickyButton) return;
    stickyButton.disabled = !selectedVariant?.available || Boolean(originalButton?.disabled) || originalButton?.getAttribute('aria-busy') === 'true';
    stickyButton.setAttribute('aria-busy', originalButton?.getAttribute('aria-busy') || 'false');
  }

  function scrollToOptions() {
    const target = mainOptions || originalButton;
    if (!target) return;
    target.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    target.querySelector('input, select, button')?.focus({ preventScroll: true });
  }

  function nativeDrawer(id, fallback, trigger) {
    for (const dialog of openedDialogs) closeDialog(dialog);
    const drawer = document.getElementById(id);
    if (drawer && 'open' in drawer) {
      drawer.open = true;
      trigger?.setAttribute('aria-expanded', 'true');
    } else {
      window.location.assign(fallback);
    }
  }

  interfaceElement.addEventListener('click', event => {
    const trigger = event.target.closest('[data-sfm-action]');
    if (!trigger || !mobile.matches) return;
    const action = trigger.dataset.sfmAction;
    if (action === 'categories') openDialog(document.getElementById('sfm-categories'), trigger);
    if (action === 'more') openDialog(document.getElementById('sfm-more'), trigger);
    if (action === 'wishlist') { renderWishes(); openDialog(wishlistDialog, trigger); }
    if (action === 'search') nativeDrawer('search-drawer', interfaceElement.dataset.searchUrl, trigger);
    if (action === 'cart') nativeDrawer('mini-cart', interfaceElement.dataset.cartUrl, trigger);
    if (action === 'options') scrollToOptions();
    if (action === 'add') {
      if (!mainForm || !originalButton || originalButton.disabled || !selectedVariant?.available) return;
      if (!mainForm.checkValidity()) { scrollToOptions(); mainForm.reportValidity(); return; }
      originalButton.click();
    }
  });

  mainForm?.addEventListener('variant:changed', event => {
    updateVariant(event.detail.variant);
    window.requestAnimationFrame(syncButton);
  });
  if (originalButton) {
    new MutationObserver(syncButton).observe(originalButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
    const visibilityObserver = new IntersectionObserver(updatePurchaseVisibility);
    visibilityObserver.observe(originalButton);
    updateVariant(selectedVariant);
  }
  new ResizeObserver(setBottomSpace).observe(bottom);
  for (const id of ['mini-cart', 'search-drawer', 'mobile-menu-drawer']) {
    const drawer = document.getElementById(id);
    if (!drawer) continue;
    new MutationObserver(() => {
      const isOpen = ['mini-cart', 'search-drawer', 'mobile-menu-drawer'].some(id => document.getElementById(id)?.hasAttribute('open'));
      root.classList.toggle('sfm-overlay', isOpen);
      interfaceElement.querySelectorAll(`[aria-controls="${id}"]`).forEach(button => button.setAttribute('aria-expanded', String(drawer.hasAttribute('open'))));
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  function updateCart(event) {
    const cart = event.detail?.cart;
    if (!cart || typeof cart.item_count !== 'number') return;
    interfaceElement.querySelectorAll('[data-sfm-count]').forEach(count => {
      count.textContent = String(cart.item_count);
      count.hidden = cart.item_count === 0 && !count.hasAttribute('data-sfm-show-zero');
    });
    if (interfaceElement.dataset.mode === 'client') interfaceElement.querySelectorAll('[data-sfm-action=cart]').forEach(button => {
      button.setAttribute('aria-label', `Carrinho, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'itens'}`);
    });
  }
  let cartRefresh = null;
  function refreshCart() {
    if (cartRefresh) return cartRefresh;
    cartRefresh = fetch(`${interfaceElement.dataset.cartUrl}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(response => response.ok ? response.json() : null)
      .then(cart => { if (cart) updateCart({ detail: { cart } }); })
      .catch(() => {})
      .finally(() => { cartRefresh = null; });
    return cartRefresh;
  }
  document.addEventListener('cart:updated', updateCart);
  document.addEventListener('cart:refresh', updateCart);
  document.addEventListener('cart:refresh', event => { if (!event.detail?.cart) refreshCart(); });
  window.addEventListener('pageshow', refreshCart);
  refreshCart();

  function keyboardState() {
    const editable = document.activeElement?.matches('input:not([type=radio]):not([type=checkbox]),select,textarea,[contenteditable=true]');
    const shortViewport = window.visualViewport && window.innerHeight - window.visualViewport.height > 120;
    root.classList.toggle('sfm-keyboard', Boolean(mobile.matches && editable && shortViewport));
  }
  window.visualViewport?.addEventListener('resize', keyboardState, { passive: true });
  document.addEventListener('focusin', keyboardState);
  document.addEventListener('focusout', () => requestAnimationFrame(keyboardState));
  mobile.addEventListener('change', () => {
    updatePurchaseVisibility();
    setBottomSpace();
    if (!mobile.matches) for (const dialog of openedDialogs) closeDialog(dialog);
  });
  window.addEventListener('pageshow', updatePurchaseVisibility);
  window.addEventListener('resize', updatePurchaseVisibility, { passive: true });
  updatePurchaseVisibility();
  setBottomSpace();
})();
